import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useGuardedNavigation } from '../../../permissions/useGuardedNavigation';

export default function MeterActionMenu({ meter }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const { navigateDetails, navigateEdit } = useGuardedNavigation('meters');

  const closeMenu = () => setAnchorEl(null);

  return (
    <>
      <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem
          onClick={() => {
            closeMenu();
            navigateDetails(meter.meter_id);
          }}
        >
          Details
        </MenuItem>
        <MenuItem
          onClick={() => {
            closeMenu();
            navigateEdit(meter.meter_id);
          }}
        >
          Edit
        </MenuItem>
      </Menu>
    </>
  );
}
